module.exports = __webpack_public_path__ + "img/yishi13.642d7ba5.jpg";